module.exports = {
      id: "messenger-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#messenger",
      toString: function () {
        return this.url;
      }
    }